import Vue from 'vue';
import Vuex from 'vuex';
/** modules */
import agentDevice from './modules/agent.device';
import agent from './modules/agent';
import device from './modules/device';
import installDevice from './modules/install.device';
import install from './modules/install';
import resource from './modules/resource';
import siteDevice from './modules/site.device';
import site from './modules/site';
import user from './modules/user';
import version from './modules/version';
/** service */
import { api, post } from '../service';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        userInfo: {
            userId: 0,
            userName: '',
            role: 1,
            agentId: 0,
            enable: 1,
            mobile: '',
            password: '',
        },
    },
    actions: {
        async getUserInfo({ commit }, data = {}) {
            const res = await post(api.user.info, data);
            commit('changeUserInfo', res);
        },
        async logout({}, data) {
            await post(api.user.logout, data);
            localStorage.removeItem('token');
        },
        changeUserInfo({ commit }, data) {
            commit('changeUserInfo', data);
        },
    },
    mutations: {
        changeUserInfo(state, data) {
            state.userInfo = data;
        },
    },
    modules: {
        agentDevice,
        agent,
        device,
        installDevice,
        install,
        resource,
        siteDevice,
        site,
        user,
        version,
    },
});
